import {getAPIKEY} from "./authentication";


export async function UnauthenticatedPostToApi(url = '', data = {}) {
    const response = await fetch(url, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache', 
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data) 
    });
    return response.json();
}

export async function AuthenticatedPostToApi(url = '', data = {}) {
    const response = await fetch(url, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'apikey': getAPIKEY()
        },
        body: JSON.stringify(data)
    });
    return response.json();
}

export async function AuthenticatedGetToApi(url = '') {
    const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'apikey': getAPIKEY()
        }
    });
    return response.json();
}


export async function FILEDOWNLOADAuthenticatedPostToApi(url = '', data = {}) {
    const response = await fetch(url, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'apikey': getAPIKEY()
        },
        body: JSON.stringify(data)
    });
    return response.blob();
}